import apiConfig from "@/configs/apiConfig";

const IMAGE_BASE_URL = apiConfig.IMAGE_BASE_URL;

export const getMenuItemImageUrl = (filename: string): string => {
  if (!filename) return "";
  return `${IMAGE_BASE_URL}/MenuItems/${filename}`;
};
export const getLogoImageUrl = (filename: string): string => {
  if (!filename) return "";
  return `${IMAGE_BASE_URL}/Logo/${filename}`;
};
export const formatCanadianPhoneNumber = (phone: string): string => {
  // Remove all non-numeric characters
  const digits = phone.replace(/\D/g, "");

  // Check if the number starts with '1' (country code), and remove it
  const cleaned =
    digits.length === 11 && digits.startsWith("1") ? digits.slice(1) : digits;

  // Make sure it has exactly 10 digits
  if (cleaned.length !== 10) return phone; // Return as-is if invalid

  const areaCode = cleaned.slice(0, 3);
  const firstPart = cleaned.slice(3, 6);
  const secondPart = cleaned.slice(6);

  return `+1 (${areaCode}) ${firstPart}-${secondPart}`;
};

export function isTokenExpired(token: string): boolean {
  try {
    const payloadBase64 = token.split(".")[1];
    const payloadJson = atob(payloadBase64);
    const payload = JSON.parse(payloadJson);

    if (!payload.exp) return true;

    const expiryTime = payload.exp * 1000; // exp is in seconds
    return Date.now() > expiryTime;
  } catch {
    return true;
  }
}

